import { useMutation } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { apiClient } from "app/modules/api-client";
import { UNSUBSCRIBE_TOAST_SUCCESS_TEXT } from "app/pages/activation/components/AlertsSubscription/texts";
import { useToasts } from "app/pages/activation/hooks/helpers/useToasts";
import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";

import { useAlertsRelatedQueriesInvalidation } from "./useAlertsRelatedQueriesInvalidation";

const UNSUBSCRIBE_FROM_ALERTS_MUTATION_KEY = "unsubscribe-from-alerts";

export const useUnsubscribeFromAlertsMutation = (activationSetId: string) => {
    const invalidateAlertsRelatedQueries = useAlertsRelatedQueriesInvalidation();
    const { showErrorToast, showSuccessToast } = useToasts();
    const email = swSettings.user?.username;

    return useMutation({
        mutationKey: [UNSUBSCRIBE_FROM_ALERTS_MUTATION_KEY],
        mutationFn: () => apiClient.Alerts.userdataActivationSubscriptionsAlertsDelete(activationSetId),
        onSuccess: async () => {
            await invalidateAlertsRelatedQueries(activationSetId);

            showSuccessToast(translate(UNSUBSCRIBE_TOAST_SUCCESS_TEXT, { email }));
        },
        onError: (error: Error) => {
            Sentry.errorTracker({
                e: error,
                message: "Error in Alerts.userdataActivationSubscriptionsAlertsDelete request",
                level: "error",
                params: {
                    extra: {
                        activationSetId,
                    },
                },
            });

            showErrorToast(translate("common.api.error", { error: error?.message }));
        },
    });
};
